<template>
  <RouterLink :to="route" custom v-slot="{ href, navigate, isActive, isExactActive }">
    <a
      :href="href"
      class="w-full flex items-center px-4 py-3 text-sm font-medium hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
      :class="[
        (exact ? isExactActive : isActive)
          ? 'bg-blue-600 bg-opacity-25 text-white'
          : 'hover:bg-blue-600 hover:bg-opacity-25 text-gray-300',
      ]"
      v-tip="{ content: tip }"
      @click="navigate"
    >
      {{ label }}
    </a>
  </RouterLink>
</template>

<script>
export default {
  props: {
    route: {
      type: [Object, String],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    tip: {
      type: String,
      default: '',
    },
    exact: Boolean,
  },
};
</script>
